import { hasAccountHint, hasExpiredGuestMarker } from './guestKitchen.js'
import { readAccountSnapshot } from './accountSnapshot.js'

/**
 * Logged-out Home cohort.
 * Returning is a device hint: this browser has held an account, even after logout.
 * Guest draft / expired draft still win so we do not overwrite an in-progress kitchen.
 */
export function resolveLoggedOutCohort(kitchen) {
  if (kitchen) return 'guest'
  if (hasAccountHint() || readAccountSnapshot()) return 'returning'
  if (hasExpiredGuestMarker()) return 'expired'
  return 'newbie'
}
